import { closeWebView } from "@socar-inc/web-frontend-libraries";
import { useRouter } from "next/router";
import { useChatBot } from "./hooks";

export const ChatbotNavigator = ({ isReady }: { isReady: boolean }) => {
  const router = useRouter();
  const { member_id, riding_id } = router.query;
  const { confirmClose } = useChatBot({ isReady, member_id, riding_id });

  return (
    <div className="tw-z-50 tw-flex tw-m-[0_auto] tw-w-[100px] tw-top-0 tw-right-0 tw-fixed">
      <span
        onClick={closeWebView}
        className="tw-w-[55px] tw-h-[67px] tw-block bg-transparent"
      />
      <span
        onClick={confirmClose}
        className="tw-w-[55px] tw-h-[67px] tw-block bg-transparent"
      />
    </div>
  );
};
